// OnDutyActionMenu.jsx
import React from "react";
import { Grid, IconButton, Tooltip, Typography, Divider } from "@mui/material";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import DeleteIcon from "@mui/icons-material/Delete";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import CloseIcon from "@mui/icons-material/Close";

const OnDutyApprovalActionMenu = ({
  isEdit,
  onSave,
  onDelete,
  onClear,
  onExit,
}) => {
  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Typography variant="h6" sx={{ ml: 1 }}>
        {isEdit ? "Edit On Duty Request" : "New On Duty Request"}
      </Typography>

      <Grid item>
        <Divider orientation="vertical" flexItem />

        <Tooltip title="Save">
          <IconButton onClick={onSave}>
            <SaveAltIcon color="success" />
          </IconButton>
        </Tooltip>

        {isEdit && (
          <Tooltip title="Delete">
            <IconButton onClick={onDelete}>
              <DeleteIcon color="error" />
            </IconButton>
          </Tooltip>
        )}

        <Tooltip title="Clear">
          <IconButton onClick={onClear}>
            <ClearAllIcon />
          </IconButton>
        </Tooltip>

        <Tooltip title="Exit">
          <IconButton onClick={onExit}>
            <CloseIcon />
          </IconButton>
        </Tooltip>
      </Grid>
    </Grid>
  );
};

export default OnDutyApprovalActionMenu;
